import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import ClientProfileDetails from '../../../../shared/ClientProfile/ClientProfileDetails';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';

export type ClientProfileScreenOwnProps = {};

export type ClientProfileScreenProps = ClientProfileScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'client-profile'>;
};

const ClientProfileScreen: React.FC<ClientProfileScreenProps> = (props) => {
    return (
        <ActionButtonLayout scrollable>
            <MainContentContainer>
                <ClientProfileDetails clientProfileId={props.route.params.profileId} />
            </MainContentContainer>
        </ActionButtonLayout>
    );
};

export default React.memo(ClientProfileScreen);
